<template>
    <div class="flex border-collapse border-b border-gray-200 draggable" :class="backgroundColor()">
        <div class="w-6 flex-shrink-0">
            <div class="px-2 py-2 w-5 h-5 flex persons-center" v-if="!readonly">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"></i>
            </div>
        </div>
        <div class="flex-1 border-l border-r" style="min-width: 55px">
            <package-contact-search
                class="flex-1"
                #default="{ open, query, setQuery }"
                @selected:contact="contactSelected"
                :top="true"
                :contacts="contacts"
                v-if="!readonly && !person.signature"
            >
                <input
                    placeholder="Name..."
                    class="flex-1 text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-20 focus:z-20 resize-none "
                    type="text"
                    ref="name"
                    v-model="person.name"
                    @input="setQuery($event.target.value);save()"
                    @focus="setQuery($event.target.value);open()"
                />
            </package-contact-search>
            <div class="flex-1 border-gray-200 px-0 py-0 overflow-x-auto relative" v-else>
                <div class="text-sm px-2 py-1">
                    {{ person.name ? person.name : "&nbsp;" }}
                </div>
            </div>
        </div>
        <div class="flex flex-0 border-r border-gray-200 justify-center items-center"
             style="min-width: 32px" ref="hardhat">
            <div class="flex m-0 p-0 justify-center items-center">
                <input type="checkbox" class="m-0" name="hardHat" :disabled="readonly || !!person.signature"
                       v-model:checked="person.hardHat" :class="!!person.signature||readonly?'bg-gray-200':''"
                       @change="save">
            </div>
        </div>
        <div class="flex flex-0 border-r border-gray-200 justify-center items-center"
             style="min-width: 32px" ref="highVisibilityVest">
            <div class="flex m-0 p-0 justify-center items-center">
                <input type="checkbox" class="m-0" name="highVisibilityVest" :disabled="readonly || !!person.signature"
                       v-model:checked="person.highVisibilityVest"
                       :class="!!person.signature||readonly?'bg-gray-200':''"
                       @change="save">
            </div>
        </div>
        <div class="flex flex-0 border-r border-gray-200 justify-center items-center"
             style="min-width: 32px" ref="boots">
            <div class="flex m-0 p-0 justify-center items-center">
                <input type="checkbox" class="m-0" name="boots" :disabled="readonly || !!person.signature"
                       v-model:checked="person.boots" :class="person.signature||readonly?'bg-gray-200':''"
                       @change="save">
            </div>
        </div>
        <div class="flex flex-0 border-r border-gray-200 justify-center items-center"
             style="min-width: 32px" ref="goggles">
            <div class="flex m-0 p-0 justify-center items-center">
                <input type="checkbox" class="m-0" name="goggles" :disabled="readonly || !!person.signature"
                       v-model:checked="person.goggles" :class="!!person.signature||readonly?'bg-gray-200':''"
                       @change="save">
            </div>
        </div>
        <div class="flex flex-0 border-r border-gray-200 justify-center items-center"
             style="min-width: 32px" ref="gloves">
            <div class="flex m-0 p-0 justify-center items-center">
                <input type="checkbox" class="m-0" name="gloves" :disabled="readonly || person.signature"
                       v-model:checked="person.gloves" :class="!!person.signature||readonly?'bg-gray-200':''"
                       @change="save">
            </div>
        </div>
        <div class="flex flex-0 border-r border-gray-200 justify-center items-center" style="min-width: 32px"
             v-for="(equipment) in otherEquipment" :key="equipment.id" ref="otherEquipment">
            <div class="flex m-0 p-0 justify-center items-center">
                <input type="checkbox" class="m-0" :name="equipment.name" :disabled="readonly || !!person.signature"
                       :class="!!person.signature||readonly?'bg-gray-200':''"
                       v-model:checked="person.selectedOtherEquipment[equipment.id]" @change="save">
            </div>
        </div>
        <div class="w-20 flex border-r border-gray-200 px-0 py-0 relative">
            <ui-dropdown placement="bottom-start" menu-class="p-3 w-56 flex" class="flex w-full"
                         trigger-class="flex w-full">
                <template #default="{ open, close }">
                    <div @mouseover="open" @mouseleave="close" class="w-full relative flex justify-center"
                         @click="() => { if (!person.signature) { addSignature(); }}">
                        <img v-if="person.signature" :src="person.signature" height="28px" width="100%"
                             class="m-0 p-0 absolute"
                             style="right:0px; top:0px; height:28px; z-index: 20">
                        <div v-else-if="person.signatureRequestedAt" class="text-blue-400 mt-0.5">
                            <i style="font-size: 11px" class="fas fa-phone"></i>...
                        </div>
                    </div>
                </template>
                <template #menu>
                    <table class="w-full" v-if="person.signatureRequestedAt">
                        <tbody>
                        <tr>
                            <td class="text-gray-600 text-xs">Signature last requested at :</td>
                        </tr>
                        <tr>
                            <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                {{ person.signatureRequestedAt }}
                            </td>
                        </tr>
                        <tr>
                            <td class="text-gray-600 text-xs">Signature last requested by:</td>
                        </tr>
                        <tr>
                            <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                {{ person.signatureRequestedBy }}
                            </td>
                        </tr>
                        <tr>
                            <td class="text-gray-600 text-xs">Signature last requested using:</td>
                        </tr>
                        <tr>
                            <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                {{ person.signatureRequestedTo }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class="w-full" v-else>
                        <tbody>
                        <tr>
                            <td class="text-gray-600 text-xs">No Signature request yet sent</td>
                        </tr>
                        </tbody>
                    </table>

                </template>
            </ui-dropdown>
        </div>
        <div class="w-6 flex-shrink-0 ml-2 mt-1">
            <template v-if="!readonly">
                <ui-dropdown menu-class="p-3 w-56"
                             v-if="person.signatureRequestedAt == null && person.signature == null">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                            <i class="fa fa-ellipsis-h fa-fw"></i>
                        </button>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-trash" danger @click="removePerson();close();">Delete Person
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </template>
            <template v-else>
                <ui-dropdown menu-class="p-3 w-56">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                            <i class="fa fa-ellipsis-h fa-fw"></i>
                        </button>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-phone" @click="sendSignatureRequest();close();">
                            Request Signature
                        </ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item icon="fas fa-pencil" @click="addSignature();close();"
                                          v-if="!person.signature">Add Signature
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-pencil" @click="addSignature();close();" v-else>Re-Sign Signature
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </template>
        </div>


    </div>
</template>

<script>
import {isNull} from "lodash";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import {PPERegister} from "@models";

export default {
    components: {
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
        PackageContactSearch
    },
    props: {
        person: Object,
        ppeRegister: Object,
        contacts: Object,
        readonly: false,
        otherEquipment: Array,
    },
    data() {
        return {}
    },
    methods: {
        addSignature() {
            this.$modals.sign({
                title: `Sign as "${this.person.name}"`,
                button: 'Confirmed',
                handle: (data) => {
                    this.ppeRegister.people.find((i) => i.id === this.person.id).signature = data.signature;
                    this.ppeRegister.update();
                }
            })
        },
        sendSignatureRequest() {
            this.$modals.open('ppe-register-signature-request', {
                title: `Send signature request to "${this.person.name}"`,
                button: 'Send signature request',
                contacts: this.contacts,
                name: this.person.name,
                handle: async (data, modal) => {
                    let person = this.ppeRegister.people.find((i) => i.id === this.person.id);
                    if (person) {
                        await this.ppeRegister.requestSignature(person.id, data.to).then(async () => {
                            let ndb = await PPERegister.find(this.ppeRegister.packageReference, this.ppeRegister.id)
                            Object.assign(this.ppeRegister, ndb)
                            modal.close()
                        })
                    }
                }
            })
        },
        backgroundColor() {
            if (this.person.signature) {
                return 'bg-green-50';
            }
            return 'bg-white';
        },
        isNull,
        getHeight(el) {
            let max = 0;
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:auto')
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                max = Math.max(max, area.scrollHeight);
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:' + max + 'px;overflow-y:hidden;')
            }
            if (this.focussed) {
                this.focussed.open();
            }
            return max + 'px';
        },
        removePerson() {
            let paragraph = [];
            if (this.person.signature) {
                paragraph.push('Warning - This person has already signed this register!');
            }
            paragraph.push('This action is irreversible. Are you sure you want to proceed?');
            this.$modals.confirmDelete({
                title: `Delete "${this.person.name}"`,
                button: 'Yes, delete this person',
                paragraphs: paragraph,
                handle: async () => {
                    this.$emit('removePerson', this.person)
                }
            })
        },
        save() {
            this.$emit('updatePerson', this.person)
        },
        contactSelected(e) {
            this.person.name = e.name
            this.save();
            this.$nextTick(() => {
                this.getHeight(this.$refs.name);
            })
        },
    },
}
</script>
